// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenSquareFilledSvg from "@ant-design/icons-svg/es/asn/CodepenSquareFilled";
import AntdIcon from '../components/AntdIcon';

var CodepenSquareFilled = function CodepenSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenSquareFilledSvg
  }));
};

CodepenSquareFilled.displayName = 'CodepenSquareFilled';
export default React.forwardRef(CodepenSquareFilled);